import {SystemResourcesReducer} from "./../pages/information-assets/models/system-resources";
import {configureStore} from "@reduxjs/toolkit";
import {ApplicationListPageReducer} from "../pages/applications/applicationList/model";
import {AppUserAccessReducer} from "../pages/applications/applicationDetail/tabs/static/userAccess/model";
import {AppReviewReducer} from "../pages/applications/applicationDetail/tabs/static/reviewHistory/model";
import config from "../common/config";
import {AppReviewTasksReducer} from "../pages/applications/applicationDetail/tabs/dynamic/review/model/model";
import {ApplicationDetailsReducer} from "../pages/applications/applicationDetail/model";
import {storeEditedTasks} from "../pages/applications/applicationDetail/tabs/dynamic/review/editedTasksLocalStorage";
import {watcher} from "../common/utils";
import {storeAppTabsMetadata} from "../pages/applications/applicationDetail/appTabsLocalStorage";
import {UserListReducer} from "../pages/users/userList/model";
import {PolicyListReducer} from "../pages/policies/policyList/model";
import {UserDetailReducer} from "../pages/users/userDetail/model";
import {storeUserTabMetadata} from "../pages/users/userList/userTabLocalStorage";
import {FeatureToggleReducer} from "../FeatureToggles/model";
import {UserGroupReducer} from "../pages/userGroups/model";
import {
    storeUserGroupDetailsTabsMetadata,
    storeUserGroupListTabsMetadata,
} from "../pages/userGroups/userGroupLocalStorage";
import {InfoTabUsersTableContentReducer} from "../components/InfoTab/model";
import {InputFieldsReducer} from "../components/condition/inputFields/model";
import {PreviewMembershipReducer} from "../pages/userGroups/KeyCondition/previewMembership/model";
import {MembersMatchingConditionListReducer} from "../pages/userGroups/PreviewKeyCondition/model";
import {KeyConditionReducer} from "../pages/userGroups/KeyCondition/model";
import {PatchUserGroupMembershipReducer} from "../pages/userGroups/KeyCondition/confirmMembership/model";
import {UserApplicationReducer} from "../pages/users/user/tabs/UserApplication/model";
import {ReviewedAccessReducer} from "../pages/users/user/tabs/userReviewedAccess/model";
import {UserGroupsListForUserViewReducer} from "../pages/users/user/model";
import {AppSideBarPageReducer} from "../parts/AppSideBar/model";
import {ResourcesReducer} from "src/pages/information-assets/models/resources";
import {InformationSystemUserGroupReducer} from "src/pages/information-assets/models/system-user-group";
import {InformationAssetsAccessesReducer} from "src/pages/information-assets/models/information-asset-accesses";
import {InformationAssetUserReducer} from "../pages/information-assets/models/information-asset-user";
import {WarningOmissionsReducer} from "src/components/warning-popconfirm/reducer";
import {storeWarningOmissions} from "src/components/warning-popconfirm/warning-selection-local-storage";
import {AccessVisibilityReducer} from "src/components/AccessVisibility/model/model";
import { CreatePolicyReducer, EditPolicyReducer, PolicyInputRequirementsReducer } from "src/pages/policies/managePolicy/model";

export const store = configureStore({
    reducer: {
        appSideBar: AppSideBarPageReducer,
        applicationList: ApplicationListPageReducer,
        appUserAccess: AppUserAccessReducer,
        appReviewHistory: AppReviewReducer,
        appReviewTasks: AppReviewTasksReducer,
        appDetails: ApplicationDetailsReducer,
        userDetail: UserDetailReducer,
        userGroupsListForUserView: UserGroupsListForUserViewReducer,
        userList: UserListReducer,
        policyInputRequirements: PolicyInputRequirementsReducer,
        policyList: PolicyListReducer,
        createPolicy: CreatePolicyReducer,
        editPolicy: EditPolicyReducer,
        userAccessHistories: UserApplicationReducer,
        reviewedAccesses: ReviewedAccessReducer,
        featureToggleList: FeatureToggleReducer,
        InfoTabUsersTableContent: InfoTabUsersTableContentReducer,
        userGroup: UserGroupReducer,
        inputFields: InputFieldsReducer,
        membersMatchingConditionList: MembersMatchingConditionListReducer,
        previewMembership: PreviewMembershipReducer,
        keyCondition: KeyConditionReducer,
        patchUserGroupMembershipResponse: PatchUserGroupMembershipReducer,
        informationAssetsAccesses: InformationAssetsAccessesReducer,
        informationSystemUserGroup: InformationSystemUserGroupReducer,
        informationAssetUser: InformationAssetUserReducer,
        resources: ResourcesReducer,
        systemResources: SystemResourcesReducer,
        warningOmissions: WarningOmissionsReducer,
        accessVisibility: AccessVisibilityReducer,
    },
    devTools: config.isEnableReduxDevTool(),
});

export type RootState = ReturnType<typeof store.getState>;
// Listen to state changes
// TODO - If number of watcher increases in the future, put then into respective storage files
const editedTasksChangeWatcher = watcher(() => store.getState().appReviewTasks.editedReviewTasks);
const appTabsMetaDataWatcher = watcher(() => store.getState().appDetails.appTabs);
const userGroupsTabsMetaDataWatcher = watcher(
    () => store.getState().userGroup.userGroupListTabStates
);
const userGroupsDetailsTabsMetaDataWatcher = watcher(
    () => store.getState().userGroup.userGroupDetailsTabStates
);
const userTabWatcher = watcher(() => store.getState().userList);
const warningOmissionsWatcher = watcher(() => store.getState().warningOmissions.list);
store.subscribe(() => {
    editedTasksChangeWatcher(storeEditedTasks);
    appTabsMetaDataWatcher(storeAppTabsMetadata);
    userGroupsTabsMetaDataWatcher(storeUserGroupListTabsMetadata);
    userGroupsDetailsTabsMetaDataWatcher(storeUserGroupDetailsTabsMetadata);
    userTabWatcher(storeUserTabMetadata);
    warningOmissionsWatcher(storeWarningOmissions);
});

// @ts-ignore
window.store = store;
